module.exports = __webpack_public_path__ + "img/ic_qianfa.eba0b9e8.png";